package com.holudi.website.components.layouts

import androidx.compose.runtime.Composable
import com.holudi.website.components.widgets.DecoLine
import com.holudi.website.models.Routes
import com.holudi.website.theme.Theme
import com.holudi.website.util.Res
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun MinimalPageLayout(
    title: String,
    content: @Composable () -> Unit
) {
    val breakpoint = rememberBreakpoint()

    Column(
        modifier = Modifier.fillMaxSize(),
        verticalArrangement = Arrangement.Top,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {

        Box(
            modifier = Modifier
//            .id("...") // anchor
                .maxWidth(1200.px)
                .padding(top = 30.px, bottom = 50.px),
            contentAlignment = Alignment.Center
        ) {


            Column(
                modifier = Modifier
                    .fillMaxWidth(
                        if (breakpoint >= Breakpoint.MD) 90.percent
                        else 80.percent
                    ),
            ) {

                Link(
                    path = Routes.HOME,
                ) {
                    Image(
                        modifier = Modifier.height(30.px),
                        src = Res.Image.LOGO_LIGHT,
                        desc = "Logo"
                    )
                }
                P(
                    attrs = Modifier
                        .fillMaxWidth()
                        .margin(top = 50.px, bottom = 0.px)
                        .fontSize(40.px)
                        .fontWeight(FontWeight.Bold)
                        .color(Theme.Colors.OnBackground.rgb)
                        .toAttrs()
                ) {
                    Text(title)
                }
                DecoLine()
                Box(modifier = Modifier.margin(top = 0.px, bottom = 50.px)) {
                    content()
                }
            }
        }
    }
}
